const zeroPadded = (number, forceToString = false) => {
  if (number.toString().length === 1) {
    return `0${number}`;
  }

  if (forceToString) return `${number}`;

  return number;
};

export default zeroPadded;



// WEBPACK FOOTER //
// ../utils/functions/zero-padded.js